import { render } from "./Index.vue?vue&type=template&id=8e1504d0"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Layout/Footer/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e1504d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e1504d0', __exports__)) {
    api.reload('8e1504d0', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=8e1504d0", () => {
    api.rerender('8e1504d0', render)
  })

}


export default __exports__